<div class="assessment-duration-calendar">
        <cygov-ngb-calendar [selectedDate]="selectedStartDate"
                [isCalendarDisabled]="disableStartDate || disableAll===3"
                [inputMinDate]="currentDateSet" [displayName]="'Start'" [dateType]="'startDate'"
                (selectedDateChange)="changeDate($event, 'startDate')"
                [inputMaxDate]="selectedEndDate" (calendarRef)="this.setCalendarRef($event, true)"
                [showCustomNavigation]="true">
        </cygov-ngb-calendar>

        <cygov-ngb-calendar [selectedDate]="selectedEndDate" [displayName]="'End'"
                [dateType]="'endDate'" [isCalendarDisabled]="disableAll===2 || disableAll===3"
                (selectedDateChange)="changeDate($event, 'endDate')"
                (calendarRef)="this.setCalendarRef($event, false)" [inputMinDate]="currentDateSet"
                [emptyEndDate]="emptyEndDate" [showCustomNavigation]="true">
        </cygov-ngb-calendar>
</div>